import type { MarketVariants } from '@/lib/i18n'

export type Slide06Copy = {
  title: string
}

export const copy: MarketVariants<Slide06Copy> = {
  US: {
    title: 'Why do they do it?',
  },
  ar: {
    title: 'لماذا يفعلون ذلك؟',
  },
}
